const base64PrefixMap: Record<string, string> = {
  '/9j/': 'image/jpeg',
  iVBORw0KGgo: 'image/png',
  R0lGOD: 'image/gif',
  PHN2Zy: 'image/svg+xml',
  AAABAAEAEBA: 'image/x-icon',
  UklGR: 'image/webp',
  Qk: 'image/bmp',
  SUkq: 'image/tiff',
  TU0A: 'image/tiff',
};

export const base64String = (stripImageString: string | null): string => {
  if (!stripImageString) throw new Error('You must provide image string');

  // Use a regex to remove data url part, for example:
  // data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWg... will bi iVBORw0KGgoAAAANSUhEUgAAAWg...
  return stripImageString.replace(/^data:image\/(png|jpeg|gif|webp|svg\+xml|x-icon);base64,/, '');
};

export const generateImageFromString = (imageString: string): string => {
  const base64StringValue = base64String(imageString);

  for (const prefix in base64PrefixMap) {
    if (base64StringValue.startsWith(prefix)) {
      const mimeType = base64PrefixMap[prefix];

      return `data:${mimeType};base64,${base64StringValue}`;
    }
  }

  return 'image/*';
};
